import React from "react";
import { motion } from "framer-motion";
import villaImg from "../../assets/villa.jpeg";
import energyImg from "../../assets/energy.png";
import performanceImg from "../../assets/efficacy.png";
import rideImg from "../../assets/efficacy.png";
import installationImg from "../../assets/easy-installation.png";
import safetyImg from "../../assets/ux-design.png";
import designImg from "../../assets/worker.png";
import spaceImg from "../../assets/high-quality.png";
import ecoImg from "../../assets/save-the-world.png";

const features = [
  { title: "Energy Efficient", description: "Consumes Low energy and works smoothly on a standard household 220-240V VAC.", icon: energyImg },
  { title: "Performance", description: "Possesses excellent beginning and stopping accuracy.", icon: performanceImg },
  { title: "Ride Quality", description: "Smooth without any disruption.", icon: rideImg },
  { title: "Installation", description: "Quick and hassle-free installation.", icon: installationImg },
  { title: "Safety", description: "Designed with integrated smart technology with emergency evacuation system to ensure safety and security.", icon: safetyImg },
  { title: "Design", description: "Elegant combination of stainless steel with colors and other suitable options, with flexibility in design.", icon: designImg },
  { title: "Space", description: "Requires minimum space, available with/without shaft and machine room and overcomes low pit and headroom shaft installations.", icon: spaceImg },
  { title: "Eco-Friendly", description: "Minimum noise levels with innovative design, gearless drive, and integrated inverter. Reduced consumption up to 75% compared to traditional lifts.", icon: ecoImg },
];

const IndivisualVilla = () => {
  return (
    <div className="max-w-7xl mx-auto px-6 py-12 space-y-28">
      
      {/* Hero Section */}
      <motion.div
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="grid md:grid-cols-2 gap-10 items-center"
      >
        <div className="space-y-6">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Elevating The Experience
          </h2>
          <p className="text-gray-700 text-lg">Product Performance Precision</p>
          <h1 className="text-2xl md:text-3xl font-semibold text-gray-800">
            Ensure Easy Access to Every Floor with WVT Elevators
          </h1>
          <p className="text-gray-600 leading-relaxed text-justify">
            WVT elevators are customizable and highly suitable with German technology for domestic purposes. These premium-class elevators come with space-saving features.
            <br /><br />
            Machine-room-less and gearless lifts are energy-efficient and can operate on single-phase power. With pitless and headroom-free designs, enjoy smooth transitions between floors.
            <br /><br />
            WVT Elevators designs solutions tailored to every home, ensuring safety, comfort, and elegance.
          </p>
        </div>
        <motion.img
          src={villaImg}
          alt="Villa Elevator"
          className="w-full h-[450px] object-cover rounded-2xl shadow-2xl"
          initial={{ opacity: 0, x: 100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        />
      </motion.div>

      {/* Features Section */}
      <div className="space-y-16">
        <motion.h2
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-3xl md:text-4xl font-bold text-center text-gray-900"
        >
          Features
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-white/60 backdrop-blur-md p-6 rounded-3xl shadow-xl flex flex-col items-center text-center hover:shadow-2xl transition-shadow duration-300"
            >
              <img src={feature.icon} alt={feature.title} className="w-16 h-16 mb-4" />
              <h4 className="font-semibold text-lg text-gray-900 mb-2">{feature.title}</h4>
              <p className="text-gray-700 text-sm">{feature.description}</p>
            </motion.div>
          ))}
        </div>

        {/* Highlighted Performance Section with Glass Blur */}
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="bg-white/20 backdrop-blur-lg border border-white/30 p-8 rounded-3xl shadow-xl flex flex-col md:flex-row items-start gap-6"
        >
          <img src={performanceImg} alt="Performance" className="w-20 h-20 md:mt-2" />
          <div className="space-y-3">
            <h3 className="text-2xl font-bold text-gray-900">Performance Upgrade</h3>
            <p className="text-gray-800 text-lg leading-relaxed">
              There is a reduced consumption by 50% in the case of WVT Elevator, unlike other traditional elevator systems and up to 75% when compared with other Hydraulic lifts.
              <br /><br />
              Extremely low energy consumption – Plug into the 220V – 240V outlet and get mesmerized with comfort in real-time.
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default IndivisualVilla;
